export default "__VITE_PUBLIC_ASSET__3cc0885c__"